module.exports = __webpack_public_path__ + "img/p1.18cb808b.png";